import React, {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import {CmsContentDecorator} from '../../services/cms/cms-content-decorator/cms-content-decorator';
import {Check} from '@sparkware/app-utils';
import { CmsPageBox } from './boxes/cms-page.box';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";

interface CmsPageComponentProps extends ComponentServicesPick<'cmsPages'> {

}

const ComponentBody: React.FC<CmsPageComponentProps> = observer((props) => {
  const services = useServices();
  const _pageContentDecorator = useRef<CmsContentDecorator | null>(null);
  const _pageContentElementRef = useRef<HTMLDivElement | null>(null);

  const _runB2CContentReadyCallback = () => {
    let contentReadyFn = services.window.getGlobalProperty('contentReady');
    if(!contentReadyFn) {
      services.logger.info(`B2C didn't provide and contentReady callback`);
      return;
    }
    if(Check.isFunction(contentReadyFn)) {
      try {
        contentReadyFn();
      } catch (err) {
        services.logger.error(`Failed to run B2C contentReady callback for page ${props.cmsPages.currentPage?.url}`);
      }
    } else {
      services.logger.warning(`B2C window.contentReady callback is not a function`);
    }
  }

  useEffect(() => {



    if(_pageContentElementRef.current) {
      let currentPage = props.cmsPages.currentPage;
      if (currentPage) {
        _pageContentElementRef.current.innerHTML = currentPage.content;
        _pageContentDecorator.current = new CmsContentDecorator(_pageContentElementRef.current, services);
        if(currentPage.elementIdToBeScrolledIntoView) {
          _pageContentDecorator.current.scrollIntoView('#' + currentPage.elementIdToBeScrolledIntoView);
        }
      }
      _runB2CContentReadyCallback();
    }

    return () => {
      if(_pageContentDecorator.current) {
        _pageContentDecorator.current.dispose();
        _pageContentDecorator.current = null;
      }
    }
  })

  if(!props.cmsPages.currentPage) {
    return null;
  }

  return (
      <CmsPageBox className={'cms-route'} ref={_pageContentElementRef} />
  );

});

export const CmsPageComponent = withServices(ComponentBody, ['cmsPages']);